import { FC } from "react";

import { useTranslation } from "react-migration/lib/i18n/useTranslation";

import { PerUnitPriceModes } from "../../../typings";

export interface PricePaidProps {
  priceMode: PerUnitPriceModes;
}
export const PricePaid: FC<PricePaidProps> = ({ priceMode }) => {
  const { t } = useTranslation();

  return (
    <div className="atlas-p-3 atlas-flex atlas-flex-row atlas-gap-y-2" data-testid="price-paid">
      <span className="atlas-w-6 atlas-h-6 atlas-shrink-0 atlas-bg-background-action atlas-rounded-full atlas-border-solid atlas-border-white atlas-border atlas-mr-2" />
      <span className="atlas-flex atlas-items-center">
        <span className="atlas-font-bold">
          {priceMode === PerUnitPriceModes.PRICE
            ? t("comparables.map.legend.price")
            : t("comparables.map.legend.est_price")}
        </span>
        <span className="atlas-px-1">-</span>
        <span>
          {priceMode === PerUnitPriceModes.PRICE
            ? t("comparables.map.legend.price_paid")
            : t("comparables.map.legend.estimated_market_value")}
        </span>
      </span>
    </div>
  );
};
